import React from "reactn";
import {
    Tooltip,
    Icon
} from "@material-ui/core";

export default function InfoToolTip({ label, title, labelStyle, id }) {
    return (
        <div style={{ display: "flex" }}>
            {label && <label style={labelStyle} htmlFor={`${id}`}>{label}</label>}
            <Tooltip title={title} placement="bottom-start">
                <Icon style={{ fontSize: 15 }}>info</Icon>
            </Tooltip>
        </div>
    );
}
